import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    listsWrapper: {
        display: 'flex',
        width: '100%',
        gap: 24,
        alignItems: 'stretch',
        // Allow children to shrink properly
        minWidth: 0,
    },
    cardsContainer: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
    },
    card: {
        width: '100%',
        maxWidth: ({ isNavbarOpen }) => isNavbarOpen ? '43rem' : '47rem',
        boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2) !important",
        borderRadius: '10px',
        transition: "0.3s",
        boxSizing: 'border-box'
    },
    arrowsColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '0 0 auto',
        gap: 8,
        paddingInline: 8,
    },
    listItem: {
        justifyContent: "flex-start",
    },
    selectedItem: {
        backgroundColor: "black",
    },
    arrows: {
        borderRadius: "50%",
        width: '35px',
        height: '35px',
        minWidth: 'unset',
        border: 'none',
        outline: ({ theme }) => `1px solid ${theme.palette.text.primary}`,
        "&.MuiButton-root": {
            color: ({ theme }) => theme.palette.text.primary,
            fontWeight: 'bold',
        }
    },
    listItemIcon: {
        minWidth: "0px"
    },
    searchField: {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            { borderColor: "#E2E8F0" },

        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
        },
    },
    cardHeader: {
        fontWeight: 'bold',
        "& .MuiCardHeader-title": {
            fontFamily: "Rubik",
            color: ({ theme }) => theme.palette.text.primary,
        },
        "& .MuiCardHeader-subheader": {
            fontFamily: "Rubik",
            color: ({ theme }) => theme.palette.text.primary,
        },
    },
    listItemText: {
        fontFamily: "Rubik",
        color: ({ theme }) => theme.palette.text.primary,
        "& .MuiListItemText-primary": {
            fontFamily: "Rubik",
            color: ({ theme }) => theme.palette.text.primary,
        }
    }

})